<template>
  <div>
    <breadcrumbs home="Term"/>

    <v-card flat width="100%">
      <v-form v-model="valid" ref="form">
        <v-container class="px-6 pt-8 purtrak-scrollable" fluid>

          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-text-field label="Name" v-model="term.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
            </v-col>
            <v-col cols="2" lg="1">
              <v-checkbox label="Active" v-model="term.active" class="mt-1"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-radio-group v-model="term.standard" dense class="mt-0" row>
                <v-radio label="Due in fixed number of days" :value="true"/>
                <v-radio label="Due by certain day of the month" :value="false"/>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row dense v-if="term.standard">
            <v-col cols="5" sm="2">
              <decimal-number-input label="Days" v-model="term.dueDays" prefix="" suffix="" :precision="0"/>
            </v-col>
          </v-row>
          <template v-else>
            <v-row dense>
              <v-col cols="5" sm="2">
                <decimal-number-input label="Day of the month" v-model="term.dayOfMonthDue" prefix="" suffix="" :precision="0"/>
              </v-col>
            </v-row>
            <v-row dense class="mb-1">
              <v-col>
                Due the next month if issued within
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="5" sm="2">
                <decimal-number-input label="Days of due date" v-model="term.dueNextMonthDays" prefix="" suffix="" :precision="0"/>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'SettingsTermsEdit',
  mixins: [confirmLeave],
  props: {
    termId: {type:String, required:false}
  },
  data() {
    return {
      term: {active:true,name:'',standard:true,dueDays:0,dayOfMonthDue:1,dueNextMonthDays:0},
      valid: true,
      dirty: false,
      saving: false
    }
  },
  watch: {
    term: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    if (this.termId) {
      const results = await this.$apiCall(`query SettingsTermsEdit($id:ID!) {
                                                term(id:$id) {
                                                  id,name,active,
                                                  standard,dueDays,dayOfMonthDue,dueNextMonthDays
                                                }
                                              }`,
                                          {id:this.termId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.term = results.data.term;
      this.$nextTick(() => this.dirty = false);
    }
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.saving = true;
      const results = await this.$apiCall(`mutation SettingsTermsEdit($input: TermInput!) {
                                             termCrupdate(input:$input) {id}
                                           }`,
                                          {input:this.term})
      this.saving = false;
      if (results.error)
        return;

      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.termId?'Updated':'Created'} term ${this.term.name}`});
      });
    },
  }
}
</script>